import { useState } from 'react';

import { useKnownAvailableParams, useNavigate } from '@change-corgi/core/react/router';
import { useTracking } from '@change-corgi/core/react/tracking';

import { useEndorsements } from '../../../hooks';

type EndorsementSectionReturn = {
	isEmpty: boolean;
	isHelpModalOpen: boolean;
	setIsHelpModalOpen: (open: boolean) => void;
	handleAddAnother: () => void;
	handleSeeExampleClick: () => void;
};

export function useEndorsementSection(): EndorsementSectionReturn {
	const { slug } = useKnownAvailableParams<{ slug: string }>();
	const navigate = useNavigate();
	const track = useTracking();
	const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

	const {
		data: { endorsements },
	} = useEndorsements({ petitionSlugOrId: slug });

	const handleAddAnother = () => {
		void track('add_petition_endorsement');
		navigate(`/p/${slug}/dashboard/endorsements/add`);
	};

	const handleSeeExampleClick = () => {
		void track('petition_manage_endorsements_example_click');
		setIsHelpModalOpen(true);
	};

	return {
		isEmpty: endorsements.length === 0,
		isHelpModalOpen,
		setIsHelpModalOpen,
		handleAddAnother,
		handleSeeExampleClick,
	};
}
